<script setup lang="ts">
import { useQuasar } from 'quasar';
import DashboardView from '../../views/DashboardView/DashboardView.vue';
import BPage from 'src/shared/components/base/BPage/BPage.vue';

const $q = useQuasar();
</script>

<template>
  <BPage :dark="$q.dark.isActive">
    <DashboardView />
  </BPage>
</template>
